import React from 'react';
import { connect } from 'react-redux';
import Loader from './../../components/loader';
import { loaderActive } from './../../action/loder'
import api from './../../service/apiService';
import { apiUrl } from './../../constants/apiUrl';
import { InHomeUtils,visitIdValidity } from './../../util/inhomeUtils';
import {setCookie} from './../../action/loopQual';
import { logKafka,  updateVisitId, catchJSException } from './../../service/logService';
import { validateVendorToken,setVendorCookie, setVendorRequest } from './../../action/loopQual2.0';
import queryString from 'query-string'
class LoopQualWidget extends React.PureComponent {
    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search); 
        const comboFlow = params.get('comboflow');
        const lq4 = params.get('lq4');
        window.vzwlqwidgetconfig = {
            targetElementId: "loopQualWidget",
            lqApi: "LOCUS_API",
            platform: "FIOS",
            scTag: "wireline",
            source: comboFlow ? "digitalCombo" : "",
            flowType: window.location.pathname.includes('/moves/') ? 'MOVERS' :'',
            autoQualOrderingRedirect: '',
            renderSettings: {
                mode: "modal",
                externalTrigger: ['.checkAvailabilityWidget'],
                miniLq: {
                    enabled: lq4?true:false,
                    layout: {}
                }
            }
        }
        if(window.location.host.indexOf('nte1aws') > -1){ 
            this.vzLqWidgetScript = this.loadScript('https://wwwnte1aws.ebiz.verizon.com/inhome/vzlqwidget.js'); 
        }
        else if(window.location.host.indexOf('nte3aws') > -1){ 
            this.vzLqWidgetScript = this.loadScript('https://wwwnte3aws.ebiz.verizon.com/inhome/vzlqwidget.js'); 
        }
        else if(window.location.host.indexOf('awssit') > -1 || window.location.host.indexOf('localhost') > -1){ 
            this.vzLqWidgetScript = this.loadScript('https://wwwawssit.ebiz.verizon.com/inhome/vzlqwidget.js'); 
        } 
        else if((window.location.host.indexOf('98.verizon.com') > -1) || (window.location.href.indexOf('lqTestQualification=Y') > -1)){ 
            this.vzLqWidgetScript = this.loadScript('https://www98.verizon.com/inhome/vzlqwidget.js'); 
        }
        else if(window.location.host.indexOf('preprod-east') > -1){ 
            this.vzLqWidgetScript = this.loadScript('https://preprod-east-gz.vpc.verizon.com/inhome/vzlqwidget.js'); 
        }
        else if(window.location.host.indexOf('wwwawsuat') > -1){ 
            this.vzLqWidgetScript = this.loadScript('https://wwwawsuat.ebiz.verizon.com/inhome/vzlqwidget.js'); 
        }           
        else{
            this.vzLqWidgetScript = this.loadScript('https://www.verizon.com/inhome/vzlqwidget.js'); 
        }       
    }
    async componentDidMount() {
        try {
            loaderActive({ isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }, this.props.dispatch);
            const params = new URLSearchParams(window.location.search); 
            const qsvalues = queryString.parse(this.props.location.search.toLowerCase());
            let cmp = qsvalues.cmp || null; 
            let cVal = qsvalues.c || null;
            let abrVal = qsvalues.abr || null;
            let doidQS = qsvalues.doid || null;
            let dig = qsvalues.dig || null;
            const vtoken = params.get('vtoken');
            const lq4 = params.get('lq4');
            let visitIdQS = '';
            let visitorIdQS = '';
            let isvtokenvalidated = false;
            let vendorInputParam = {
                abrVal,
                cVal,
                cmp: cmp || "",
                doidQS: doidQS || "",
                dig: dig || ""
            };
            if(lq4){
                setTimeout(() => {
                    window.vzlqw?.closeModal()
                }, 2000);
            }
            // Changes for Midnight CETC deployment
            if(params.get('MN') === 'Y') {
                window.sessionStorage.setItem('isMidnight', true);
            }
            if(params.get('agency') === 'CETCORDER2') {
                window.sessionStorage.setItem('isWIFI7', true);
            }
            this.cookie_VisitId = window.localStorage.getItem("visit_id");
            if(vtoken){
                let response = await validateVendorToken(vtoken, this.props);
                if (response && response.data) {
                    isvtokenvalidated = response.data.tokenvalidated,
                    visitIdQS = response.data.visitId,
                    visitorIdQS = encodeURIComponent(response.data.visitorId);

                    if(visitIdQS && visitorIdQS){
                        await setVendorCookie(visitIdQS, visitorIdQS)                      
                    }
                }
            }
            let useCookieVisitId = isvtokenvalidated || false; //true;
            const isVisitIdMatching = await visitIdValidity(this.props.dispatch, useCookieVisitId, visitIdQS, visitorIdQS, true);
            if (!isVisitIdMatching) {
                const visitidUrl = apiUrl().createVisitId;
                api(visitidUrl, 'GET', '').then(response => {
                    if (InHomeUtils.isNotEmpty(response) && InHomeUtils.isNotEmpty(response.visit_id) && InHomeUtils.isNotEmpty(response.visitor_id)) {
                        window.localStorage.setItem('visit_id', response.visit_id);
                        window.localStorage.setItem('visitor_id', response.visitor_id);
                        window.localStorage.setItem('expirationTime', response.expirationTime);
                        window.sessionStorage.setItem('visit_id', response.visit_id);
                    }
                    const { cookies } = this.props;
                    setCookie(cookies, response, this.props);
                    if (response && response.visit_id) {
                        updateVisitId(response.visit_id);
                    }
                    if (InHomeUtils.isNotNull(vendorInputParam) && InHomeUtils.isNotNull(vendorInputParam.cVal) && InHomeUtils.isNotNull(vendorInputParam.abrVal) && InHomeUtils.isNotEmpty(response.visit_id) && InHomeUtils.isNotEmpty(response.visitor_id)) {
                        setVendorRequest(this.props.dispatch, response.visit_id, response.visitor_id, vendorInputParam,  false)
                    }
                }).catch(error => {
                    let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                    logKafka("ERROR", "checkAvailability", error.message, getErrorLogUrl, "applogs", cookie_VisitId);
                });
            }
            
            setTimeout(() => {
                loaderActive({ isLoaderActive: false }, this.props.dispatch);
            }, 2000);
        }
        catch (ex) {
            catchJSException('checkAvailability', this.props.appState.visitId, 'componentDidMount', ex);
        }
    }
    loadScript = (url) => {
        try{
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        document.body.appendChild(script);
        }
        catch(ex)
        {
            catchJSException('LoopQualWidget',this.props.appState.visitId,'loadScript',ex);
        }
    };
    render() {
        return (<React.Fragment>
            <Loader /> 
            <div>     
            <div id="loopQualWidget"></div>
            </div>      
        </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        appState: state.app
    }
}
export default connect(
    mapStateToProps,
)(LoopQualWidget);